<template>
  <v-container>
    <h2 class="text-center my-12">{{ $t("home.title") }}</h2>
    <p class="text-center mb-0">{{ $t("home.description") }}</p>
    <p class="text-center mt-1 mb-12 text-body-medium">{{ $t("home.note") }}</p>
    <v-card :disabled="loading" :loading="loading" class="mx-auto my-12" to="/palworld" max-width="1200">
      <v-img :src="palworldHeader" cover></v-img>
      <v-card-item>
        <v-card-title>Palworld</v-card-title>
        <v-card-subtitle>
          <span class="me-1">{{ $t("home.palworld.subtitle") }}</span>
        </v-card-subtitle>
      </v-card-item>
    </v-card>
    <v-card :disabled="loading" :loading="loading" class="mx-auto my-12" to="/craftopia" max-width="1200">
      <v-img :src="craftopiaHeader" cover></v-img>
      <v-card-item>
        <v-card-title>Craftopia</v-card-title>
        <v-card-subtitle>
          <span class="me-1">{{ $t("home.craftopia.subtitle") }}</span>
        </v-card-subtitle>
      </v-card-item>
    </v-card>
  </v-container>
</template>

<script>
import palworldHeader from '@/assets/img/header_palworld.jpg'
import craftopiaHeader from '@/assets/img/header_craftopia.jpg'

export default {
  name: 'HomeView',
  data() {
    return {
      palworldHeader,
      craftopiaHeader,
    }
  }
}
</script>
